module.exports = __webpack_public_path__ + "img/tr.dc3f6b17.svg";